import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/pricing-time";

export async function getPricingTimeListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function createPricingTimeRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function getPricingTimeByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function updatePricingTimeRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}

export async function deletePricingTimeRequest(id) {
  const response = await baseGeospatial.delete(`${BASE_URL}/delete/${id}`);
  return response.data;
}
